import React from "react";
import { View } from "react-native";
import Text from "@/components/shared/AppText";
import tw from "twrnc";

const Bullet = ({ children, condensed, textStyle, isChecked }) => (
  <View style={tw`flex-row items-start ${condensed ? "mb-1" : "mb-6"}`}>
    <View style={tw`w-2.5 mr-2.5 flex items-center justify-center`}>
      <Text style={tw`text-lg ${condensed ? "text-sm" : ""}`}>
        {isChecked ? "\u2713" : "\u2022"}
      </Text>
    </View>
    <Text style={[tw`flex-1 text-lg ${condensed ? "text-sm" : ""}`, textStyle]}>
      {children}
    </Text>
  </View>
);

export default Bullet;
